import { render, staticRenderFns } from "./POS.vue?vue&type=template&id=54dca5c9"
import script from "./POS.vue?vue&type=script&lang=js"
export * from "./POS.vue?vue&type=script&lang=js"
import style0 from "./POS.vue?vue&type=style&index=0&id=54dca5c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports